import { useContext } from 'react';

import MaterialsCaptureContext from '../../context/MaterialsCaptureContext';

import Box from "@mui/material/Box";
import Divider from '@mui/material/Divider';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import SendSharpIcon from '@mui/icons-material/SendSharp';

const MaterialsCaptureFooter = () => {
  const { 
    stepIndex, handleAdd, handlePrevClick, handleSubmit
  } = useContext(MaterialsCaptureContext);
  
  return(
    <Box>
      <Divider 
        sx={{
          '&::before, &::after': {
            borderColor: 'grey.900',
          },
        }}
      >
        <ControlPointIcon 
          sx={{ marginTop: 1, cursor: 'pointer'}} 
          fontSize="large"
          color="success"
          onClick={handleAdd}
        />
      </Divider>

      <Stack direction="row" spacing={1} justifyContent="flex-end" mr={1}>
        {
          stepIndex !== 0 &&
          <Button 
            variant="outlined" 
            startIcon={<ArrowBackIcon />} 
            onClick={handlePrevClick}
          >
            Prev
          </Button>
        }

        {
          stepIndex === 10 ?
            <Button 
              variant="contained" 
              endIcon={<SendSharpIcon />} 
              onClick={handleSubmit}
            >
              Submit
            </Button>
            :
            <Button 
              variant="outlined" 
              endIcon={<ArrowForwardIcon />} 
              onClick={handleSubmit}
            >
              Next
            </Button>
        }
      </Stack>
    </Box>
  );
};

export default MaterialsCaptureFooter;